import { inject, Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { PaypalCaptureResponse, PaypalCaptureStatus } from "./models/paypal/paypal-capture-response.model";
import { ApiWrapperService } from "ngx-apiwrapper";
import { map, Observable } from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class PayPalService {
    private readonly _apiWrapper = inject(ApiWrapperService);
    private readonly paypalClientId = environment.paypal.PAYPAL_SANDBOX ? environment.paypal.PAYPAL_SANDBOX_CLIENT_ID : environment.paypal.PAYPAL_CLIENT_ID;
    private readonly paypalSecret = environment.paypal.PAYPAL_SANDBOX ? environment.paypal.PAYPAL_SANDBOX_CLIENT_SECRET : environment.paypal.PAYPAL_CLIENT_SECRET;    


    createOrder(bookingID: number): Observable<string>  {
        return this._apiWrapper.post<string>('payments/paypal/create-order/' + bookingID, null, {
            responseType: 'text'
        })
    }

    captureOrder = async (orderID: string) => {
        const accessToken = await this.generateAccessToken();
        this._apiWrapper.post<PaypalCaptureResponse>(`v2/checkout/orders/${orderID}/capture`, {}, {
            headers: {
                "Authorization": `Bearer ${accessToken}`,
                "Content-Type": "application/json"
            },
            apiName: 'paypal'
        }).subscribe()
    }

    getMerchantIds(bookingID: number): Observable<string>  {
        return this._apiWrapper.get<string>('payments/paypal/merchant-id/' + bookingID, {
            responseType: 'text'
        })
    }
    
    generateAccessToken = async() => {
        try {
            if (environment.paypal.PAYPAL_SANDBOX) {
                if (!this.paypalClientId || !this.paypalSecret) {
                    throw new Error("MISSING_API_CREDENTIALS");
                }
            }

            const auth = Buffer.from(
                this.paypalClientId + ":" + this.paypalSecret,
            ).toString("base64");

            await this._apiWrapper.post<any>('v1/oauth2/token',"grant_type=client_credentials",
                {
                    headers: {
                        "Authorization": `Basic ${auth}`,
                        "Content-Type": "application/json"
                    },
                    apiName: 'paypal'
                }
            ).subscribe(data => {
                return data["access_token"]
            })
            
            // const response = await fetch(`${this.base}/v1/oauth2/token`, {
            //     method: "POST",
            //     body: "grant_type=client_credentials",
            //     headers: {
            //         Authorization: `Basic ${auth}`,
            //     },
            // });
    
            // const data = await response.json();
            // return data.access_token;
        } catch (error) {
            console.error("Failed to generate Access Token:", error);
        }
    };
}